import { render } from "./SettingsItemView.vue?vue&type=template&id=aba11c18"
import script from "./SettingsItemView.vue?vue&type=script&lang=js"
export * from "./SettingsItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__